//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilterCheckbox from "./Filter.vue";

export default {
	name: "CaroFilters",
	components: {
		FilterCheckbox,
	},
	props: {
		filters: Array,
		results: Object,
		setFilterValue: Function,
		executeSearch: Function,
	},
};
